import React from 'react';
import { NavLink, Redirect, Route, RouteComponentProps, Switch } from 'react-router-dom';
import { Icon, Menu, Message } from 'semantic-ui-react';

import { RestringidosDe } from './RestringidosDe';

const Restringidos = (props: RouteComponentProps) => {
    const rutaBase = props.match.path;

    return (
        <>
            <Message negative size='large' icon>
                <Icon name='ban' />
                Estos alumnos deben ser dirigidos a cobranzas de inmediato.
            </Message>

            <Menu tabular>
                <Menu.Item as={NavLink} to={rutaBase + '/clases'} content='De clases' />
                <Menu.Item as={NavLink} to={rutaBase + '/material'} content='De material' />
                <Menu.Item as={NavLink} to={rutaBase + '/puntajes'} content='De puntajes' />
            </Menu>

            <Switch>
                <Redirect exact from={rutaBase} to={rutaBase + '/clases'} />
                <Route
                    path={rutaBase + '/clases'}
                    render={() => (
                        <RestringidosDe key='clases' comando='alumnosRestringidosDeClases' />
                    )}
                />
                <Route
                    path={rutaBase + '/material'}
                    render={() => (
                        <RestringidosDe key='material' comando='alumnosRestringidosDeMaterial' />
                    )}
                />
                <Route
                    path={rutaBase + '/puntajes'}
                    render={() => (
                        <RestringidosDe key='puntajes' comando='alumnosRestringidosDePuntajes' />
                    )}
                />
            </Switch>
        </>
    );
};

export default Restringidos;



// WEBPACK FOOTER //
// ./src/modulos/Alumnos/paginas/Restringidos/index.tsx